//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
SPLM.AnimationDesigner.Convention = Object.freeze({
    "Xyz" : "Xyz", "Xzy" : "Xzy", "Yxz" : "Yxz", "Yzx" : "Yzx", "Zxy" : "Zxy", "Zyx" : "Zyx", "Xyx" : "Xyx", "Xzx" : "Xzx", "Yxy" : "Yxy", "Yzy" : "Yzy", "Zxz" : "Zxz", "Zyz" : "Zyz"});

export default SPLM;